import React, { forwardRef } from 'react'
import styled from 'styled-components'
import { MqTablet, MqDesktop } from 'streamr-ui/css/consts'
import Container from '~shared/Container'

const UnstyledCaseStudyTextWrapper = forwardRef(function UnstyledCaseStudyTextWrapper(
    { children, ...props },
    ref,
) {
    return (
        <div {...props} ref={ref}>
            <Container>{children}</Container>
        </div>
    )
})

const CaseStudyTextWrapper = styled(UnstyledCaseStudyTextWrapper)`
    color: #0c009a;

    p {
        font-size: 16px;
        line-height: 28px;
        margin: 0;
        padding: 0;

        @media ${MqTablet} {
            font-size: 18px;
            line-height: 30px;
            padding: 0 56px;
        }

        @media ${MqDesktop} {
            padding: 0 232px;
        }
    }

    p + p {
        /* Keep it the same as p's line-height. */
        margin-top: 28px;

        @media ${MqTablet} {
            margin-top: 30px;
        }
    }
`

export default CaseStudyTextWrapper
